import Head from "next/head";
const MetaData = ({ image, title, description, width, height, url, titleData, host, pathName, enableAds, enableAdsQa, pageType, noIndexNoFollow, script, sourceTopicPage, enableTwitterScript, background, canonicalUrl, disableFontFace = false, breadcrumbScript, fullUrl }) => {
  let imageWidth = width ? width : "200";
  let imageHeight = height ? height : "200";
  let metaTitle = title ? '@' + title + " • Josh, India’s #1 short videos app" : "• Josh, India’s #1 short videos app";
  let metaDescription = "Made in India • Discover the latest and trending short videos and profiles";
  let metaUrl = url ? url : '';
  let imageUrl = image ? (image ? image.replace('webp', 'jpg') : image) : 'https://share.myjosh.in/static/images/josh/josh_logo.png';
  if (pageType == 'detail') {
    titleData = script && script.description || titleData;
    metaTitle = title ? title + " • Josh, India’s #1 short videos app" : "• Josh, India’s #1 short videos app";
  } else if (pageType == 'challenge') {
    metaTitle = title ? '#' + title + " • Josh, India’s #1 short videos app" : "• Josh, India’s #1 short videos app";
  } else if (pageType == 'audio' || pageType == 'duet') {
    titleData = pageType == 'duet' ? title : titleData;
    metaTitle = title ? title + " • Josh, India’s #1 short videos app" : "• Josh, India’s #1 short videos app";
  } else if (pageType == 'room') {
    metaTitle = title;
    metaDescription = description
  } else if (pageType == 'zone') {
    metaTitle = title ? title + " • Josh, India’s #1 short videos app" : "• Josh, India’s #1 short videos app";
    metaDescription = description;
    imageUrl = image;
  } else if (pageType == 'nochange') {
    metaTitle = title;
    metaDescription = description;
    imageUrl = image;
  } else if (pageType == 'audioPodcast') {
    titleData = title;
    metaDescription = description || "Your latest destination for short, snacky and trending viral videos! Available in multiple languages - हिंदी, ಕನ್ನಡ, தமிழ், తెలుగు, മലയാളം, मराठी, ગુજરાતી, বাংলা, ଓଡିଆ, English";;
    imageUrl = image || 'https://share.myjosh.in/static/images/josh/josh_logo.png';
  } else {
    titleData = 'Josh - India’s own short video app';
    metaDescription = "Your latest destination for short, snacky and trending viral videos! Available in multiple languages - हिंदी, ಕನ್ನಡ, தமிழ், తెలుగు, മലയാളം, मराठी, ગુજરાતી, বাংলা, ଓଡିଆ, English";
  }

  let encodedMetaUrl = encodeURIComponent(metaUrl);
  let urlIncludesContent = fullUrl && fullUrl.includes('content/')
  // Keywords for Home page
  let keywordsHome = ["whatsapp viral video", "short comedy videos", "comedy short video", "romantic short video", "short video", "funny status video", "comedy videos for whatsapp", "whatsapp funny video", "funny video app", "short funny videos", "funny short video", "funny whatsapp status video", "tik tok video", "tiktok download apk", "tiktok video viral app", "tiktok songs",
    "tik tok watch online", "tik tok", "app similar to tik tok", "tik tok app", "indian tiktok app", "tiktok app", "apk tik tok download", "tiktok", "tiktok for download", "josh short video app", "josh video app", "josh indian video app", "josh india app"];
  const enableKeywords = pathName && pathName == '/suggestionPage';
  const keywordsString = keywordsHome.join(', ');
  script && script.thumbnailUrl && (script.thumbnailUrl = script && script.thumbnailUrl && script.thumbnailUrl.replace('.webp', '.jpg'))
  return (
    <Head>
      <title>{titleData}</title>
      <meta name="description" content={metaDescription} />
      {enableKeywords && <meta name="keywords" content={keywordsString} />}
      {/* Twitter OG */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@share.myjosh.in" />
      <meta name="twitter:creator" content="@Josh" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />
      {/* Generic OG */}
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content={imageWidth}></meta>
      <meta property="og:image:height" content={imageHeight}></meta>
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaUrl} />
      <meta property="fb:app_id" content="204487420876685"></meta>
      <meta property="og:type" content="article"></meta>
      <meta name="Josh Videos" content={`app-id=1530819820, affiliate-data=myAffiliateData, app-argument=${encodedMetaUrl}`}></meta>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
      <link rel="manifest" href="/manifest.webmanifest.json" />
      <meta name="robots" content="index" />
      {enableAds && <script id="adTag" src="https://assets-money.dailyhunt.in/adtag.min.js?origin=webitem&env=prod&zone=web&partnerRef=" />}
      {enableAdsQa && <script id="adTag" src="https://qa-money.newshunt.com/adtag.min.js?origin=pwa&env=qa" />}
      {sourceTopicPage && <script id="adTag" src="https://assets-money.dailyhunt.in/adtag.min.js?env=prod&origin=webitem" />}
      {script && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(script) }}></script>}
      {breadcrumbScript && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbScript) }}></script>}
      {background && <style dangerouslySetInnerHTML={{ __html: "body,html{background:black !important}" }}></style>}
      {enableTwitterScript && <script src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>}
      {enableTwitterScript && <script src="https://www.youtube.com/iframe_api" charSet="utf-8"></script>}
      {canonicalUrl && urlIncludesContent && <link rel="canonical" href={canonicalUrl} />}
      {!disableFontFace && <style dangerouslySetInnerHTML={{ __html: "@font-face{font-family:en;src:url(/static/fonts/en/NotoSans-Regular.ttf) format('truetype');font-style:normal" }} />}

    </Head>
  )
}


export default MetaData;
